module.exports = __webpack_public_path__ + "img/near5.4f3fc44c.jpg";